// AccountPlans.tsx

import { AccountLayoutWrapper } from "containers/AccountPage/AccountLayoutWrapper";
import React, { useState } from "react";
import ButtonPrimary from "shared/Button/ButtonPrimary";

const AccountPlans: React.FC = () => {
  const plans = [
    {
      title: "Plan 1",
      description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
      bulletPoints: ["Point 1", "Point 2", "Point 3"],
    },
    {
      title: "Plan 2",
      description:
        "Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
      bulletPoints: ["Point 1", "Point 2", "Point 3"],
    },
    {
      title: "Plan 3",
      description:
        "Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris.",
      bulletPoints: ["Point 1", "Point 2", "Point 3"],
    },
  ];

  const [editMode, setEditMode] = useState(false);
  const [editedTitle, setEditedTitle] = useState("");
  const [editedDescription, setEditedDescription] = useState("");
  const [editedBulletPoints, setEditedBulletPoints] = useState<string[]>([]);

  const handleEditClick = (
    title: string,
    description: string,
    bulletPoints: string[]
  ) => {
    setEditMode(true);
    setEditedTitle(title);
    setEditedDescription(description);
    setEditedBulletPoints([...bulletPoints]);
  };

  const handleSaveClick = () => {
    setEditMode(false);
    // Handle save logic here
  };

  const handleCancelClick = () => {
    setEditMode(false);
  };

  return (
    <AccountLayoutWrapper>
    <div className="flex flex-wrap justify-center gap-4">
        {plans.map((plan, index) => (
                 <div key={index} className="m-4 p-6 bg-white rounded-lg shadow-md w-80 h-96 overflow-hidden flex flex-col">

            {editMode ? (
              <>
                <input
                  type="text"
                  value={editedTitle}
                  onChange={(e) => setEditedTitle(e.target.value)}
                  className="mb-2 border-b-2 border-gray-300 w-full"
                />
                <textarea
                  value={editedDescription}
                  onChange={(e) => setEditedDescription(e.target.value)}
                  className="mb-4 border-b-2 border-gray-300 w-full h-32 overflow-auto"
                />
                <ul className="list-disc pl-4 mb-4">
                  {editedBulletPoints.map((point, i) => (
                    <li key={i}>{point}</li>
                  ))}
                </ul>
                <div className="mt-auto flex justify-end">
                  <ButtonPrimary
                  className="mt-auto px-4 py-2"
                  onClick={handleSaveClick}
                  >
                    Save
                  </ButtonPrimary>
                  <ButtonPrimary
                  className="mt-auto ml-4 px-4 py-2"
                  onClick={handleCancelClick}
                  >
                    Cancel
                  </ButtonPrimary>
                </div>
              </>
            ) : (
              <>
                <h2 className="text-xl font-bold mb-2">{plan.title}</h2>
                <p className="text-gray-600 mb-4 h-32 overflow-auto">
                  {plan.description}
                </p>
                <ul className="list-disc pl-4 mb-4">
                  {plan.bulletPoints.map((point, i) => (
                    <li key={i}>{point}</li>
                  ))}
                </ul>
                <ButtonPrimary
                  className="mt-auto px-4 py-2"
                  onClick={() =>
                    handleEditClick(
                      plan.title,
                      plan.description,
                      plan.bulletPoints
                    )
                  }
                >
                  Edit
                </ButtonPrimary>
              </>
            )}
          </div>
        ))}
      </div>
    </AccountLayoutWrapper>
  );
};

export default AccountPlans;
